const normalizeText = (value) => {
  return String(value ?? '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toLowerCase()
    .trim();
};

export const matchesSearchTerm = (searchTerm, ...values) => {
  const term = normalizeText(searchTerm);

  if (!term) {
    return true;
  }

  return values.some((value) => normalizeText(value).includes(term));
};
